export const obtenerFondosTestnet = [
    {
      title: "Cómo obtener fondos de prueba en las redes Sepolia y Amoy (Polygon) usando faucets y tu wallet",
      value: `
  Sigue este procedimiento para recibir ETH de prueba en Sepolia o POL de prueba en Amoy. El proceso es similar en ambas testnets, solo cambia el tipo de token y la faucet utilizada.
  
  ---
  
  1. **Accede a la faucet oficial de la testnet**  
     - Para **Sepolia**, busca una faucet de Sepolia como [faucet.sepolia.dev](https://faucet.sepolia.dev/) o la recomendada por tu curso.
     - Para **Amoy (Polygon)**, puedes usar la faucet oficial que se enlaza desde la documentación de Polygon o desde [https://faucet.polygon.technology/](https://faucet.polygon.technology/).
  
  2. **Abre tu wallet y selecciona la red correcta**  
     Accede a tu wallet (MetaMask, MyEtherWallet, etc.) y asegúrate de estar conectado a la red de prueba correcta:
     - Selecciona **Sepolia** si quieres recibir ETH de prueba.
     - Selecciona **Amoy (Polygon Testnet)** si quieres recibir POL de prueba.
  
  3. **Copia tu dirección pública**  
     Dentro de tu wallet, localiza tu dirección pública (empieza con “0x…”).  
     Haz clic en el botón para copiarla.  
     Es importante que no uses la clave privada, solo la dirección pública.
  
  4. **Solicita los fondos en la faucet**  
     Pega tu dirección en el campo correspondiente de la faucet y haz clic en el botón para solicitar los tokens de prueba.  
     Dependiendo de la faucet, podrías tener que realizar una verificación (como firmar un mensaje, resolver un captcha o iniciar sesión con GitHub).
  
  5. **Verifica la llegada de los fondos**  
     Regresa a tu wallet y revisa tu saldo.  
     - En **Sepolia**, verás reflejado el saldo de ETH de prueba.
     - En **Amoy**, verás reflejado el saldo de POL de prueba.  
     También puedes consultar la transacción en un explorador de bloques (Sepolia Etherscan o Amoy Polygonscan).
  
  ---
  
  **Recomendaciones:**  
  - Cada faucet puede tener un límite de tiempo o cantidad diaria.  
  - Los fondos en estas redes de prueba solo sirven para practicar y aprender, no tienen valor real.
  
  ¡Listo! Ya tienes fondos de prueba y puedes usarlos para desplegar contratos, realizar transacciones y experimentar en un entorno seguro.
  
  En la siguiente sección te mostraré cada uno de estos pasos con imágenes y explicaciones detalladas.
  `
    }
  ];
  
  export default obtenerFondosTestnet;
  